import { GetDeviceParameterData } from "/Foundation/Common/code/Helpers/TrackingHelper";
import { AdobeAnalyticsUtil } from "/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil";

export const track_addToList = (productIds, type) => {
    if (!productIds?.length > 0 || !type) return;
    const distinctIds = [...new Set(productIds)];
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent('RFG_addToList', {
        device: deviceData,
        RFG: {
            type,
            products: distinctIds.join('|')
        }
    });
}

export const track_tabClick = (tab, type) => {
    if (!tab || !type) return;
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent('RFG_productTab', {
        device: deviceData,
        RFG: {
            type,
            tab
        }
    });
}

export const track_shareLink = (type) => {
    if (!type) return;
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent('RFG_shareLink', {
        device: deviceData,
        RFG: {
            type,
        }
    });
}

export const track_linkClick = (linkClick) => {
    if (!linkClick) return;
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent('RFG_linkClick', {
        device: deviceData,
        RFG: {
            linkClick
        }
    });
}

export const track_toggleJourney = (show, type) => {
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent(`RFG_${show ? 'open' : 'close'}_${type}`, {
        device: deviceData,
    });
}

export const track_fitTip = (type) => {
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent(`RFG_open_fitTips`, {
        device: deviceData,
        RFG: {
            type,
        }
    });
}

export const track_download = (downloadId) => {
    if (!downloadId) return;
    const deviceData = GetDeviceParameterData();
    AdobeAnalyticsUtil.DataLayer.TrackEvent('RFG_download', {
        device: deviceData,
        RFG: {
            downloadId
        }
    });
}